(() => {
"use strict";
const CDN = "";
const SLIDES = [
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/Web_1920_3_2.webp",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/hero-1-compressed.jpg",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/benefit-6-compressed.jpg",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/benefit-7-compressed.jpg",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/fcf145fdbaf8-Web_1920_25.png",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/fa897ef90864-Web_1920_Co_19.png",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/4738ea5cb4fe-Web_1920_12_2.png",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/1c95931d5861-Web_1920_Co_26.png"
];
const PACKED = [
  [
    "Raw Cacao",
    "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/95c9ff81db3a-raw-cacao-enhanced.webp"
  ],
  [
    "Cinnamon",
    "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/a336845ff03d-ingredient-cinnamon_d3b6fb54-a24b-44a4-8fb0-481f70a9cb5e.webp"
  ],
  [
    "Turmeric",
    "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/31dff785856f-turmeric.png"
  ],
  [
    "Black Pepper",
    "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/175ae6e108a8-ground_pepper.png"
  ],
  [
    "MCT Oil",
    "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/a3b57bb6c1a6-ingredient-mct-powder_5f20ca5e-074d-46a8-8cc7-e5c194441f9d.webp"
  ],
  [
    "Monk Fruit",
    "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/51c5ef179c5e-ingredient-monk-fruit_b5c3952f-5ac3-4623-afaa-1ed7b0354068.webp"
  ],
  [
    "Lucuma",
    "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/aec48c0ac5ac-ingredient-lucuma_6c5d6751-98cf-4841-b258-95d35ed9682a.avif"
  ],
  [
    "Sea Salt",
    "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/7f20695dd1f6-ingredient-sea-salt.jpg"
  ]
];
const SHORT_REVIEWS = [
  {
    "title": "\"My jeans are fitting better\"",
    "body": "Cacao Bliss has become my favorite healthy treat. When I stepped on the scale this morning I was already down a pound and a half in one week, and I definitely feel less bloated.",
    "name": "Amber F."
  },
  {
    "title": "\"No more late night sugar cravings\"",
    "body": "Since I started drinking Cacao Bliss my pants have been feeling looser and I'm not getting those late night sugar cravings, so that's been huge for me.",
    "name": "Chris W."
  },
  {
    "title": "\"It keeps me full most of the day\"",
    "body": "I've been doing a lot of intermittent fasting and it helps satiate my cravings. It keeps me full throughout most of the day, and it's helped my focus too.",
    "name": "Alex G."
  },
  {
    "title": "\"Better from the inside out\"",
    "body": "It tastes like a cozy, rich hot chocolate but without all the junk. I use it to replace my evening treat, and I don't hit that 3 p.m. energy wall like I used to.",
    "name": "Donna L."
  },
  {
    "title": "\"I'm noticing it around my waist\"",
    "body": "My jeans fit better. I've lost a few pounds and I'm noticing it around my waist. Even my friends have commented, what are you doing?",
    "name": "Leah K."
  },
  {
    "title": "\"Two inches off my waist\"",
    "body": "I've lost about five pounds and about two inches off my waist. I've gone through my closet and can wear clothes I haven't worn in a long time.",
    "name": "Rick S."
  }
];
const LONG_REVIEWS = [
  {
    "initials": "MT",
    "name": "Marissa T",
    "ago": "12 minutes ago",
    "title": "Finally something sweet that fits",
    "body": "I'm eating so much less these days and dessert was the one thing I missed. A warm cup at night completely handles it and I'm not derailing my progress.",
    "product": "Review for Cacao Bliss: Original / 30 Servings",
    "photo": null
  },
  {
    "initials": "JG",
    "name": "Judith G",
    "ago": "48 minutes ago",
    "title": "Rich and creamy, no chalk",
    "body": "Absolutely love the flavor. I was expecting that gritty superfood taste and it just is not there. Tastes like real chocolate.",
    "product": "Review for Cacao Bliss: Original / 90 Servings",
    "photo": "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/d3a9f0519e75-Rectangle_1113.png"
  },
  {
    "initials": "AW",
    "name": "Andre W",
    "ago": "1 hour ago",
    "title": "Kept my labs steady",
    "body": "Down 34 pounds over the year and my bloodwork held. My dietitian asked what I was drinking, which felt like a win.",
    "product": "Review for Cacao Bliss: Original / 90 Servings",
    "photo": null
  },
  {
    "initials": "JL",
    "name": "Joy L",
    "ago": "2 hours ago",
    "title": "Goes down on the hard days",
    "body": "Most mornings I don't want to eat anything at all. This still goes down easily and I stop feeling shaky by mid-morning.",
    "product": "Review for Cacao Bliss: Original / 30 Servings",
    "photo": null
  },
  {
    "initials": "CH",
    "name": "Cheryl H",
    "ago": "3 hours ago",
    "title": "A great daily reward",
    "body": "Easy to make and I enjoy keeping up with my minerals and antioxidants without thinking about it. Ten seconds and done.",
    "product": "Review for Cacao Bliss: Original / 30 Servings",
    "photo": "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/external/4c37717118bd-Rectangle_1115.png"
  },
  {
    "initials": "DP",
    "name": "Diane P",
    "ago": "4 hours ago",
    "title": "Telling all my girlfriends",
    "body": "This makes me even happier to have my hot chocolate because it doesn't have all of the added sugar. And bonus, my jeans are fitting better.",
    "product": "Review for Cacao Bliss: Original / 90 Servings",
    "photo": null
  },
  {
    "initials": "RS",
    "name": "Rick S",
    "ago": "5 hours ago",
    "title": "Significant changes in a few weeks",
    "body": "I've lost about five pounds and two inches off my waist. I can fit into these jeans again.",
    "product": "Review for Cacao Bliss: Original / 90 Servings",
    "photo": null
  },
  {
    "initials": "LJ",
    "name": "Lara J",
    "ago": "6 hours ago",
    "title": "Seeing results on the scale",
    "body": "I have a ton of cravings for chocolate. I've been trying it for a couple of weeks now and I'm starting to see some results on the scale. Really excited.",
    "product": "Review for Cacao Bliss: Original / 30 Servings",
    "photo": null
  }
];
const HERO_SLIDES = [
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/hero-1-compressed.jpg",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/benefit-2-compressed.jpg",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/benefit-6-compressed.jpg",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/benefit-5-compressed.jpg",
  "https://cdn.earthechofoods.com/earthechofoods/cacao-bliss/listicle2/20261008/uploads/benefit-7-compressed.jpg"
];
class Listicle {
  state = { qty: 'three', plan: 'sub', slide: 0, hero: 0, labelOpen: false, showBar: false, showMobileBar: false, count: 1, prog: 0 };
  setState(update) { Object.assign(this.state, typeof update === 'function' ? update(this.state) : update); this.update?.(); }
  goHero(index) { this.heroStarted = performance.now(); this.setState({hero: (index + HERO_SLIDES.length) % HERO_SLIDES.length, prog: 0}); }
  renderVals() {
    const s = this.state;
    const three = s.qty === 'three';
    const sub = s.plan === 'sub';
    const subPrice = three ? '$117' : '$49';
    const oncePrice = three ? '$240' : '$80';
    return {
      statsRef: this.statsRef,
      stat1: Math.round(73000 * (s.count || 0)).toLocaleString('en-US') + '+',
      stat3: Math.round(6 * (s.count || 0)) + 'x',
      stat4: (4.8 * (s.count || 0)).toFixed(1) + '★',
      showBar: s.showBar,
      showMobileBar: s.showMobileBar,
      labelOpen: s.labelOpen,
      openLabel: () => this.setState({ labelOpen: true }),
      closeLabel: () => this.setState({ labelOpen: false }),
      heroSrc: HERO_SLIDES[s.hero],
      heroPrev: () => this.goHero(s.hero - 1),
      heroNext: () => this.goHero(s.hero + 1),
      heroDots: HERO_SLIDES.map((_, i) => ({
        fill: (i < s.hero ? 100 : i === s.hero ? Math.round((s.prog || 0) * 100) : 0) + '%',
        pick: () => this.goHero(i)
      })),
      slideSrc: SLIDES[s.slide],
      prevSlide: () => this.setState({ slide: (s.slide + SLIDES.length - 1) % SLIDES.length }),
      nextSlide: () => this.setState({ slide: (s.slide + 1) % SLIDES.length }),
      thumbs: SLIDES.map((src, i) => ({
        src,
        border: i === s.slide ? '#f07d1a' : 'transparent',
        pick: () => this.setState({ slide: i })
      })),
      packedWith: PACKED.map(([name, file]) => ({ name, src: CDN + file })),
      shortReviews: SHORT_REVIEWS,
      longReviews: LONG_REVIEWS,

      pickOne: () => this.setState({ qty: 'one' }),
      pickThree: () => this.setState({ qty: 'three' }),
      oneBorder: three ? '#eee0c8' : '#f07d1a',
      oneBg: three ? '#ffffff' : '#fff8ef',
      threeBorder: three ? '#f07d1a' : '#eee0c8',
      threeBg: three ? '#fff8ef' : '#ffffff',

      pickSub: () => this.setState({ plan: 'sub' }),
      pickOnce: () => this.setState({ plan: 'once' }),
      subBorder: sub ? '#f07d1a' : '#eee0c8',
      subBg: sub ? '#fff8ef' : '#ffffff',
      subDot: sub ? '#f07d1a' : '#ffffff',
      onceBorder: sub ? '#eee0c8' : '#f07d1a',
      onceBg: sub ? '#ffffff' : '#fff8ef',
      onceDot: sub ? '#ffffff' : '#f07d1a',
      subServings: three ? '90 servings, ships every 90 days' : '30 servings, ships every 30 days',
      onceServings: three ? '90 servings delivered once' : '30 servings delivered once',
      subBadge: three ? 'MOST POPULAR: GET 51% OFF' : 'GET 38% OFF',
      subPrice,
      oncePrice,
      compareAt: oncePrice,
      subPerServing: three ? '$1.30/serving' : '$1.63/serving',
      oncePerServing: three ? '$2.67/serving' : '$2.67/serving',
      ctaPrice: sub ? subPrice : oncePrice
    };
  }
}
﻿const root = document.getElementById('listicle2');
if (!root) return;
const component = new Listicle();
const get = (values, key) => key.trim().split('.').reduce((value, part) => value?.[part], values);
const bindings = [...root.querySelectorAll('[data-listicle-text], [data-listicle-src], [data-listicle-style], [data-listicle-show]')];
let previousFocus;
let previousOverflow;
component.update = () => {
  const values = component.renderVals();
  bindings.forEach(element => {
    if (element.dataset.listicleText) {
      const text = String(get(values, element.dataset.listicleText) ?? '');
      if (element.textContent !== text) element.textContent = text;
    }
    for (const name of ['src', 'style']) {
      const format = element.getAttribute('data-listicle-' + name);
      if (!format) continue;
      const value = format.replace(/\[\[(.*?)\]\]/g, (_, key) => get(values, key) ?? '');
      if (element.getAttribute(name) !== value) element.setAttribute(name, value);
    }
    if (element.dataset.listicleShow) element.hidden = !get(values, element.dataset.listicleShow);
  });
  for (const [action, selected] of Object.entries({pickOne: component.state.qty === 'one', pickThree: component.state.qty === 'three', pickSub: component.state.plan === 'sub', pickOnce: component.state.plan === 'once'})) {
    root.querySelectorAll('[data-listicle-action="' + action + '"]').forEach(el => el.setAttribute('aria-pressed', String(selected)));
  }
  const option = window.listicleCheckoutOptions?.[component.state.qty + '-' + component.state.plan];
  const cta = root.querySelector('[data-listicle-checkout]');
  if (option) {
    const url = new URL('/products/cacao-bliss', location.origin);
    url.searchParams.set('variant', option.variantId);
    if (option.sellingPlanId) url.searchParams.set('selling_plan', option.sellingPlanId);
    cta.href = window.preserveUrlParams ? window.preserveUrlParams(url.href) : url.href;
  }
};
const closeModal = () => {
  component.setState({labelOpen: false});
  document.body.style.overflow = previousOverflow || '';
  previousFocus?.focus();
};
root.addEventListener('click', event => {
  const target = event.target.closest('[data-listicle-action]');
  if (!target || !root.contains(target)) return;
  const key = target.dataset.listicleAction;
  if (key === 'closeLabel') {
    if (target.classList.contains('cb-203') && event.target !== target) return;
    closeModal(); return;
  }
  if (key === 'openLabel') {
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  get(component.renderVals(), key)?.();
  if (key === 'openLabel') root.querySelector('.cb-205').focus();
});
root.addEventListener('keydown', event => {
  if (component.state.labelOpen) {
    if (event.key === 'Escape') { event.preventDefault(); closeModal(); }
    if (event.key === 'Tab') { event.preventDefault(); root.querySelector('.cb-205').focus(); }
  }
  const target = event.target.closest('[role="button"][data-listicle-action]');
  if (target && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); target.click(); }
});
let pending = false;
root.querySelector('[data-listicle-checkout]').addEventListener('click', async event => {
  if (!window.EmptyCheckout) return;
  event.preventDefault();
  if (pending) return;
  const cta = event.currentTarget;
  const error = root.querySelector('[data-listicle-error]');
  const option = window.listicleCheckoutOptions?.[component.state.qty + '-' + component.state.plan];
  error.hidden = true;
  if (!option?.available || (component.state.plan === 'sub' && !option.sellingPlanId)) {
    error.textContent = 'This option is currently unavailable. Please choose another option.';
    error.hidden = false; return;
  }
  pending = true; cta.setAttribute('aria-busy', 'true');
  try { await window.EmptyCheckout.checkout(option); }
  catch (failure) { error.textContent = failure.message || 'Unable to open checkout. Please try again.'; error.hidden = false; }
  finally { pending = false; cta.removeAttribute('aria-busy'); }
});
let scrollQueued = false;
const onScroll = () => {
  if (scrollQueued) return;
  scrollQueued = true;
  requestAnimationFrame(() => {
    scrollQueued = false;
    const rect = root.querySelector('.cb-114').getBoundingClientRect();
    const show = window.scrollY > 700 && !(rect.top < innerHeight && rect.bottom > 0) && !component.state.labelOpen;
    const wide = innerWidth > 900;
    component.setState({showBar: show && wide, showMobileBar: show && !wide});
  });
};
window.addEventListener('scroll', onScroll, {passive: true});
window.addEventListener('resize', onScroll);
const motion = matchMedia('(prefers-reduced-motion: reduce)');
component.heroStarted = performance.now();
let timer;
const start = () => {
  clearInterval(timer);
  if (motion.matches || document.hidden) return;
  component.heroStarted = performance.now();
  timer = setInterval(() => {
    if (component.state.labelOpen) { component.heroStarted = performance.now(); return; }
    const progress = (performance.now() - component.heroStarted) / 5000;
    if (progress >= 1) component.goHero(component.state.hero + 1);
    else component.setState({prog: progress});
  }, 100);
};
motion.addEventListener('change', start);
document.addEventListener('visibilitychange', start);
window.addEventListener('pagehide', () => clearInterval(timer));
window.addEventListener('pageshow', start);
component.update(); onScroll(); start();

})();
